export const key = 'intended_dest';

// Only update the intended dest if it isn't already set
export function setDestIfNeeded(dest: string) {
  const existingDest = localStorage.getItem(key);
  if (existingDest) {
    return;
  }
  if (!dest) {
    // grab the full file path with query parameters if not set
    dest = window.location.href.slice(window.location.origin.length);
  }

  // skip saving destination for login related APIs (/login or /login/verify) to prevent loops
  // login/authorize is intended to be saved though as it is part of an initialized oauth flow
  // so it should still be saved.
  if (dest.startsWith('/login') && !dest.startsWith('/login/authorize')) {
    return;
  }

  // skip saving root urls as intended destinations since they are already the default destinations
  if (dest === '/dash' || dest === '/') {
    return;
  }

  // TODO: also save a timestamp here and expire these after a while
  localStorage.setItem(key, dest);
}

export function popDest(): string | null {
  const dest = localStorage.getItem(key);
  if (dest) {
    localStorage.removeItem(key);
  }
  return dest;
}

export function getDest(): string | null {
  return localStorage.getItem(key);
}
